import { Box } from '@mui/material';

import { BreakingMarketCardSkeleton } from './BreakingMarketCardSkeleton';

const ROW_COUNT = 4;

export const BreakingMarketsListSkeleton = () => {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '16px',
        overflow: 'hidden',
        bgcolor: 'background.paper',
      }}
    >
      {Array.from({ length: ROW_COUNT }).map((_, index) => (
        <BreakingMarketCardSkeleton
          key={`breaking-market-skeleton-${index}`}
          showDivider={index < ROW_COUNT - 1}
        />
      ))}
    </Box>
  );
};

export default BreakingMarketsListSkeleton;
